import { formFieldsConfigProcessed } from "./config/IncidentDetailsConfig";
import { formFieldsState } from "./state/IncidentDetailsState";
import { formFieldsValidation } from "./validations/IncidentDetailsValidations";
import { INCIDENT_DETAILS_CONSTANTS } from "../../constants";

export const formName = INCIDENT_DETAILS_CONSTANTS.FORM_NAME;
export const formHeader = INCIDENT_DETAILS_CONSTANTS.FORM_HEADER;
export const formDescription = INCIDENT_DETAILS_CONSTANTS.FORM_DESCRIPTION;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;
export const formState = formFieldsState;
